import theme from '../../../utils/theme';
import { defaults } from 'chart.js';

defaults.global.defaultFontFamily = theme.typography.fontFamily;
